(function() { window.GUID_e780795d_083e_4dc1_ba6f_c9d65fb9076c = { getGuid: function() { return "e780795d-083e-4dc1-ba6f-c9d65fb9076c"; } }; })();
var CS;
(function (CS) {
    var DataRange;
    (function (DataRange) {
        class ReadOnlyDataRange {
            constructor(data) {
                this.data = data;
            }
            get minValue() { return this.data.minValue; }
            get maxValue() { return this.data.maxValue; }
        }
        DataRange.ReadOnlyDataRange = ReadOnlyDataRange;
        /** this class expose an readonly IDataRange instance. It assure the instance will not get replaced with a new instance. */
        class ReadOnlyDataRangePropertyHelper {
            constructor(data) {
                this.data = data;
                if (data)
                    this.dateRange = data;
                else
                    this.dateRange = { maxValue: null, minValue: null };
                this.dateRangeInstance = new ReadOnlyDataRange(this.dateRange);
            }
            get DataRangeReadOnly() { return this.dateRangeInstance; }
            SetData(data) {
                this.dateRange.maxValue = data.maxValue;
                this.dateRange.minValue = data.minValue;
                this.valueChange("all");
            }
            get minValue() { return this.dateRange.minValue; }
            set minValue(value) { this.dateRange.minValue = value; this.valueChange("minValue"); }
            get maxValue() { return this.dateRange.maxValue; }
            set maxValue(value) { this.dateRange.maxValue = value; this.valueChange("maxValue"); }
            valueChange(valueName) {
                if (this.ValueChangedCallback)
                    this.ValueChangedCallback(valueName);
            }
        }
        DataRange.ReadOnlyDataRangePropertyHelper = ReadOnlyDataRangePropertyHelper;
    })(DataRange = CS.DataRange || (CS.DataRange = {}));
})(CS || (CS = {}));

//# sourceMappingURL=cs-data-range.js.map
